import React from 'react';
import {MobileMenu} from '../HeaderMobileMenu/HeaderMobileMenu';
import {HeaderLogo} from '../HeaderLogoBlock/HeaderLogoBlock';
import {HeaderMenu} from '../HeaderMenu/HeaderMenu';
import {HeaderActions} from '../HeaderActions/HeaderActions';
import { TextField } from "@arctheme-components/elements/TextField/TextField";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export default function HeaderLayoutLeft({ links, item_count = '', settings, show_search_bar = false }) {
    const isMobile = useMobileBreakpoint(settings.breakpoint);
    const textClass = isMobile ? 'b_tiny_normal' : 'b_regular_normal';
    return (
        <div className={`w-full lg:flex items-center lg:items-${settings.section.header_text_position_desktop} justify-between relative lg:py-[10px]`}>
            <MobileMenu link_list={links} settings={settings}/>
            <HeaderLogo settings={settings} className={`${textClass} justify-center`}/>

            <HeaderMenu link_list={links} settings={settings}/>

            {show_search_bar && <div className={'header-search'}>
                <TextField id={'search'} placeholder={'Search...'} value={''}/>
            </div>}
            <HeaderActions item_count={item_count} settings={settings}/>
        </div>
    );
}